import React, { useEffect, useRef, useState } from "react";
import { ChevronDown } from "react-bootstrap-icons";

/**
 * Zone de texte d'introduction scrollable avec :
 * - un ascenseur toujours visible (classe .intro-scroll, voir index.css) ;
 * - un dégradé + chevron en bas tant qu'il reste du contenu à faire défiler
 *   (les scrollbars overlay de certains mobiles restant peu visibles).
 */
export default function IntroScrollBox({ maxHeight, style, children }) {
  const scrollRef = useRef(null);
  const [canScrollDown, setCanScrollDown] = useState(false);

  const updateScrollHint = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollDown(el.scrollHeight - el.scrollTop - el.clientHeight > 8);
  };

  useEffect(() => {
    updateScrollHint();
    // Re-vérifier après le rendu du HTML injecté (images, polices)
    const timer = setTimeout(updateScrollHint, 500);
    window.addEventListener("resize", updateScrollHint);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", updateScrollHint);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children]);

  return (
    <div style={{ position: "relative", ...style }}>
      <div
        ref={scrollRef}
        onScroll={updateScrollHint}
        className="intro-scroll"
        style={{
          textAlign: "left",
          maxHeight,
          overflowY: "auto",
          paddingRight: "12px",
        }}
      >
        {children}
      </div>
      {canScrollDown && (
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: "12px",
            height: "56px",
            background:
              "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.95))",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <ChevronDown
            size={20}
            style={{ color: "#718096", marginBottom: "2px" }}
            className="intro-scroll-chevron"
          />
        </div>
      )}
    </div>
  );
}
